import { ReactNode } from 'react';
import { RoomBackground } from '../Room/RoomBackground';

interface AppPageShellProps {
  children: ReactNode;
  maxWidthClass?: string;
  className?: string;
}

export function AppPageShell({
  children,
  maxWidthClass = 'max-w-[820px]',
  className = '',
}: AppPageShellProps) {
  return (
    <div className={`room-page min-h-screen min-w-0 ${className}`}>
      <RoomBackground />
      <div
        className={`room-page-content mx-auto w-full px-3 pb-10 pt-7 ${maxWidthClass}`}
      >
        {children}
      </div>
    </div>
  );
}
